var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02244 16C3.13941 16 4.04489 15.0945 4.04489 13.9775C4.04489 12.8606 3.13941 11.9551 2.02244 11.9551C0.905479 11.9551 0 12.8606 0 13.9775C0 15.0945 0.905479 16 2.02244 16Z",
    fill: "#130D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02244 10.0234C3.13941 10.0234 4.04489 9.11792 4.04489 8.00096C4.04489 6.88399 3.13941 5.97852 2.02244 5.97852C0.905479 5.97852 0 6.88399 0 8.00096C0 9.11792 0.905479 10.0234 2.02244 10.0234Z",
    fill: "#130D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02244 4.04489C3.13941 4.04489 4.04489 3.13941 4.04489 2.02244C4.04489 0.905479 3.13941 0 2.02244 0C0.905479 0 0 0.905479 0 2.02244C0 3.13941 0.905479 4.04489 2.02244 4.04489Z",
    fill: "#130D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsMenuIcon);
export default __webpack_public_path__ + "static/media/three-dots-menu-icon.2522d85bae048bcf24b80c2b32cae0da.svg";
export { ForwardRef as ReactComponent };